import { S, DC, ACL } from '../../Utilities';


export default class Gmap {
    
    constructor(options) {
        this.Map = document.querySelector('footer .map');

        if (this.Map) {
            const Loc = this.Map.getAttribute('data-loc').split(',');

            this.options = Object.assign({}, {
                lat: parseFloat(Loc[0]),
                lng: parseFloat(Loc[1]),
                center_lat: parseFloat(Loc[0]),
                center_lng: parseFloat(Loc[1]),
                zoom: 14,
                el: this.Map
            }, options);

            this.controller();
        }
    }

    

    renderMap() {
        const Icon = new google.maps.MarkerImage('/theme/bovero/images/marker.png', null, null, null, new google.maps.Size(50,56));
        this.map = new google.maps.Map(this.options.el, {
            zoom: this.options.zoom,
            disableDefaultUI: true,
            scaleControl: true,
            scrollwheel: false,
            zoomControl: true,
            center: {
                lat: this.options.center_lat,
                lng: this.options.center_lng
            }
        });
        this.marker = new google.maps.Marker({
            position: this.options,
            map: this.map,
            icon: Icon,
            flat: true
        });
    }

    openMap() {
        const MPel = DC('div');
        const closeBtn = DC('span');
        const closeBtn_1 = DC('span');
        const closeBtn_2 = DC('span');
        const MPCont = DC('div');
        const body = S('body');
        const Icon = new google.maps.MarkerImage('/theme/bovero/images/marker.png', null, null, null, new google.maps.Size(50,56));

        ACL(MPel, 'map_show');
        ACL(MPCont, 'map_el');
        ACL(closeBtn, 'close_btn full_screen');
        ACL(closeBtn_1, 'close_cross_1');
        ACL(closeBtn_2, 'close_cross_2');

        
        body.appendChild(MPel);
        MPel.appendChild(MPCont);
        MPel.appendChild(closeBtn);
        closeBtn.appendChild(closeBtn_1);
        closeBtn.appendChild(closeBtn_2);

    
        const map = new google.maps.Map(MPCont, {
            zoom: this.options.zoom,
            disableDefaultUI: true,
            scaleControl: true,
            scrollwheel: false,
            zoomControl: true,
            center: {
                lat: this.options.center_lat,
                lng: this.options.center_lng
            }
        });

        this.marker = new google.maps.Marker({
            position: this.options,
            map,
            icon: Icon,
            flat: true
        });


        closeBtn.addEventListener('click', () => {
            body.removeChild(MPel);
        });
    }

    controller() {
        const mapFrame = S('.coll_3 .map_frame');
        google.maps.event.addDomListener(window, 'load', () => this.renderMap() );
        mapFrame.addEventListener('click', e => this.openMap() );
    }

}